export const notificationGroups = {
  name: '通知群組 |||| 通知群組',
  list: {
    title: '通知群組',
    subtitle: '管理通知群組及其成員',
    members: '成員',
    filters: {
      search: '按名稱或描述搜尋',
      type: '類型',
      active: '狀態',
    },
  },
  create: {
    title: '建立通知群組',
    subtitle: '設定新的通知接收群組',
    backToList: '返回通知群組',
  },
  edit: {
    title: '編輯通知群組',
    subtitle: '管理群組設定和成員',
    backToList: '返回通知群組',
  },
  delete: {
    confirmTitle: '刪除通知群組',
    confirmContent: '確定要刪除此通知群組嗎？此操作無法撤銷。',
  },
  fields: {
    name: '群組名稱',
    description: '描述',
    type: '類型',
    channels: '通知渠道',
    memberCount: '成員',
    active: '啟用',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    createdBy: '建立者',
    updatedBy: '更新者',
    metadata: '其他資料',
  },
  types: {
    site: '站點',
    charger: '充電樁',
    payment: '付款',
    system: '系統',
    custom: '自訂',
  },
  channels: {
    email: '電子郵件',
    sms: '簡訊',
    whatsapp: 'WhatsApp',
    push: '推送通知',
    slack: 'Slack',
  },
  help: {
    name: '此通知群組的唯一名稱',
    description: '群組用途的選擇性描述',
    type: '此群組處理的通知類型',
    channels: '此群組的預設通知渠道',
    active: '停用的群組將不會收到通知',
  },
  sections: {
    basicInfo: '基本資訊',
    channelsConfig: '通知渠道設定',
    metadata: '其他資料',
  },
  tabs: {
    general: '一般',
    members: '成員',
    assignments: '指派',
  },
  assignments: {
    title: '資源指派',
    addButton: '新增指派',
    loading: '載入指派中...',
    noAssignments: '尚無資源指派',
    noAssignmentsHelp: '將此群組指派給站點、充電樁或其他資源以接收通知',
    info: '此群組已指派給以下資源。要管理指派，請前往通知指派。',
  },
  members: {
    title: '群組成員',
    empty: '此群組尚無成員',
    add: '新增成員',
    remove: '移除',
    editChannels: '編輯渠道',
    overridden: '已覆蓋',
    loadError: '載入成員失敗',
    addSuccess: '成員新增成功',
    addError: '新增成員失敗',
    updateSuccess: '成員更新成功',
    updateError: '更新成員失敗',
    removeSuccess: '成員移除成功',
    removeError: '移除成員失敗',
    selectAtLeastOne: '請至少選擇一個使用者',
    loadUsersError: '載入使用者失敗',
    fields: {
      name: '名稱',
      email: '電子郵件',
      role: '角色',
      channels: '渠道',
      active: '啟用',
      addedAt: '加入時間',
      actions: '操作',
    },
    removeConfirm: {
      title: '移除成員',
      content: '確定要從此群組移除 %{name} 嗎？',
    },
    addDialog: {
      title: '新增成員到群組',
      search: '按名稱或電子郵件搜尋使用者',
      noUsers: '沒有可新增的使用者',
      selectUsers: '已選擇 %{count} 個使用者',
      overrideChannels: '覆蓋預設渠道',
      selectChannels: '選擇通知渠道',
      add: '新增 %{count} 個成員',
    },
    editDialog: {
      title: '編輯成員設定',
      active: '啟用成員',
      activeHelp: '停用的成員將不會收到通知',
      overrideChannels: '覆蓋群組渠道',
      usingGroupChannels: '此成員使用群組的預設渠道',
      selectChannels: '為此成員選擇通知渠道',
      groupChannels: '群組預設渠道',
      resetToGroup: '重設為群組預設',
    },
  },
  notifications: {
    createSuccess: '通知群組建立成功',
    updateSuccess: '通知群組更新成功',
    deleteSuccess: '通知群組刪除成功',
  },
};